<template>
  <div class="box" style="background-color:  #eeeeee; border: 1px solid #cccccc; width: 280px;">
    <div v-if="currentLanguage==0">
      <div class="title" style="font-size: 16pt;margin-bottom: 8px">Bodenkarten</div>
      <div style="font-size: 12pt;"><a href="https://www.wsl.ch/de/projekte/hochaufloesende-bodenkarten-fuer-den-schweizer-wald.html" target="_blank">Informationen +</a></div>
    </div>
    <div v-if="currentLanguage==1">
      <div class="title" style="font-size: 16pt;margin-bottom: 8px">Cartes des sols</div>
      <div style="font-size: 12pt;"><a href="https://www.wsl.ch/fr/projets/hochaufloesende-bodenkarten-fuer-den-schweizer-wald.html" target="_blank">Informations +</a></div>
    </div>
    <div v-if="currentLanguage==2">
      <div class="title" style="font-size: 16pt;margin-bottom: 8px">Soilmap</div>
      <div style="font-size: 12pt;"><a href="https://www.wsl.ch/en/projects/high-resolution-soil-maps-for-the-swiss-forest.html" target="_blank">Informations +</a></div>
    </div>
    <Language/>
  </div>
</template>

<script>
import Language from "./Language";

export default {
  name: "Header",
  components: {
    Language
  },
  data () {
    return {
      catalogs: [],
      err: '',
      expanded: true,
    }
  },
  computed: {
    /*token() {
      return this.$store.state.token
    },*/
    currentLanguage() {
      return this.$store.getters.currentLanguage
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.active {
  background-color: aquamarine;
}

.icon-open {
  transform: rotate(90deg);
}
.icon-closed {
  transform: rotate(270deg);
}
.icon {
  cursor: pointer;
  top: 0;
  right: 0;
  float: right;
  font-size: 12pt;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}
.icon:hover {
  opacity: 1;
}

</style>
